export const ACCEPTED_STATUS = 'Y';
export const NOT_ACCEPTED_STATUS = 'N';
export const GAMING_DECLARATION_PATH = '/gaming-declaration';
export const IS_POST_LOGIN = '1';
